import { createActions } from 'redux-actions';
import { normalize } from 'normalizr';
import { API } from 'aws-amplify';

import * as t from './actionTypes';
import * as schema from './schema';
import { getApp } from './selectors';
import misc from '../misc';

const actionCreators = createActions({
  [t.ENTITIES_ADD]: [entities => entities, () => ({ updatedAt: Date.now() })],
  [t.NETWORK_START]: undefined,
  [t.NETWORK_RESET]: undefined,
  [t.NETWORK_ERROR]: undefined,
  [t.ACTIVE_SET]: undefined,
  [t.SEARCH_SET]: undefined
});

/**
 * Fetch records from API
 */
export const fetchLocations = () => async dispatch => {
  dispatch(actionCreators.locations.networkStart());
  let res;
  try {
    res = await API.get('ptapp', '/locations');
  } catch (e) {
    dispatch(actionCreators.locations.networkError(e.message));
    return;
  }
  const data = normalize(res, schema.locationList);
  dispatch(actionCreators.locations.entitiesAdd(data.entities.locations));
  dispatch(actionCreators.locations.networkReset());
};

/**
 * Fetch records from API if cache has expired
 */
export const fetchLocationsIfNeeded = () => async (dispatch, getState) => {
  const app = getApp(getState());
  const lastUpdate = app && app.get('lastUpdate');
  const cacheTime = Date.now() - lastUpdate;
  if (lastUpdate === null || cacheTime > 60000 * 5) {
    // 5 minute cache
    fetchLocations()(dispatch);
  }
};

/**
 * Update record through API
 * @param  {object} values  New values for record
 * @param  {object} history react-router-dom history
 */
export const submitLocationEdit = (values, history) => async dispatch => {
  dispatch(actionCreators.locations.networkStart());
  let res, id;
  try {
    if (typeof values.id === 'undefined') {
      res = await API.post('ptapp', '/locations', { body: values });
      id = res.id;
    } else {
      res = await API.put('ptapp', `/locations/${values.id}`, { body: values });
      id = values.id;
    }
    const data = normalize(res, schema.location);
    dispatch(actionCreators.locations.entitiesAdd(data.entities.locations));
  } catch (e) {
    dispatch(actionCreators.locations.networkReset());
    misc.lib.throwSubmissionErrorFromAxiosError(e);
  }

  dispatch(actionCreators.locations.activeSet(id));
  // history.push('/locations/' + id);
  dispatch(actionCreators.locations.networkReset());
};

/**
 * Set active record
 * @param {string} id The ID of the record to set as active
 */
export const setActive = id => async dispatch => {
  dispatch(actionCreators.locations.activeSet(id));
};

/**
 * Set search term
 * @param {string} term The new search term
 */
export const setSearch = term => async dispatch => {
  dispatch(actionCreators.locations.searchSet(term));
};



// WEBPACK FOOTER //
// ./src/modules/locations/actions.js